import { UserProfile } from './user-profile';
import { dataMember, required, typedArray } from 'santee-dcts';

export class UserProfilesReadModel {
    @dataMember()
    @required()
    public currentPage: number;

    @dataMember()
    @required()
    public totalPages: number;

    @dataMember()
    @required()
    @typedArray(UserProfile)
    public users: UserProfile[];
}